import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import AboutUs from "@/pages/AboutUs";

export const Route = createFileRoute("/pl/about-us")({
  head: () => routeHead('O AGAPE — Zespół i podejście', META_DESCRIPTIONS.about.pl, '/pl/about-us'),
  component: AboutUs,
});
